var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"member-active-curve flex-center"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticStyle:{"width":"100%","height":"200px"},attrs:{"id":"chartCurve"}})])}
var staticRenderFns = []

export { render, staticRenderFns }